import Tabs from './Tabs';
import TabPanel from './TabPanel';

export default Tabs;
export {
  TabPanel,
};
